import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import { stashLinkEvent } from '../../utils/analytics';
export var SecurityAlert = function () {
    return (React.createElement("div", { className: "sui-mb-6 sm:sui-mb-12" },
        React.createElement(Alert, { status: "info" },
            React.createElement(Typography, null,
                "Visit the",
                ' ',
                React.createElement(Link, { href: "/myaccount/security" },
                    React.createElement("span", { onClick: function () {
                            return stashLinkEvent('profile page: link: security and password page');
                        }, role: "link", tabIndex: 0 }, "Security & Password")),
                ' ',
                "page to update your account email, password, contact phone and signed-in devices."))));
};
